import { Component } from "preact";
import IdleTimeout from "./other/IdleTimeout";
import RouteListener from "./other/RouteListener";
import Footer from "./other/Footer";
import { E_Route } from "../models/constants/Enum_Routes";
import HelpPage from "../routes/Information/InformationPage";
import ConfigurationPage from "../routes/Configuration/ConfigurationPage";
import Toaster from "./other/Toast/Toaster";
import Header from "./other/Header";
import { GlobalModal, HeartbeatRequester } from "../components/components";
import RouterSwitch from "./other/RouterSwitch";
import LocationRequester from "./other/LocationRequester";
import Keyboard from "./Keyboard/Keyboard";
import Router from "preact-router";
import { APP_CONSTANTS } from "../models/constants/AppConstants";
import Fa from "./shared/Fa";
import SocketListener from "./other/SocketListener";
import TermsPage from "../routes/Information/TermsPage";
import { healthServices } from "../services/health-services";
import PropTypes from "prop-types";

class App extends Component {
	render({configuration}) {
		return (
			<div id={"root"}>
				<IdleTimeout/>
				<RouteListener/>
				<GlobalModal/>
				<Toaster/>
				<Keyboard/>
				<SocketListener/>

				<main>
					<Header/>

					<Router onChange={(e) => {
						window.dispatchEvent(new CustomEvent(APP_CONSTANTS.ROUTE_UPDATE_EVENT_NAME, {detail: e}));
						window.keyboard.close();
					}}>
						<TermsPage path={E_Route.TERMS}/>
						<HelpPage path={E_Route.HELP}/>
						<ConfigurationPage path={E_Route.CONFIGURATION}/>
						<LocationRequester default>
							<RouterSwitch/>
							<HeartbeatRequester
								shouldRefresh={!!configuration.frontendID}
								service={() => healthServices.sendHeartbeat(configuration.frontendID, {
									store: window.store.getState(),
									lastInteraction: window.lastInteraction,
								})}
							/>
						</LocationRequester>
					</Router>

					<div className={"graphics"}>
						<hr className={"split-left no-style"}/>
						<hr className={"split-right no-style"}/>
						<Fa icon={"cubesave-luggage"}/>
					</div>

					<Footer/>
				</main>

				<div id={"modalRoot"}/>
			</div>
		);
	}

	static get propTypes() {
		return {
			configuration: PropTypes.object,
		}
	}
}

export default App;
